import { Label, Textarea } from "@f2e/ui/components/base"
import { useTranslation } from "react-i18next"

import { resolveLocalizedText } from "../registry"
import type {
  AgentTemplateRequestFormFieldDefinition,
  AgentTemplateToolValue,
} from "../types"
import { ConfigurableFieldShell } from "./ConfigurableFieldShell"
import type { TemplateItemRendererProps } from "./TemplateItemRenderer"

export const RequestFormItemRenderer = ({
  item,
  locale,
  value,
  error,
  disabled,
  onChange,
}: TemplateItemRendererProps) => {
  const { t } = useTranslation()
  if (item.type !== "tool_request_form") return null
  const definition = item as AgentTemplateRequestFormFieldDefinition
  const current = (value as AgentTemplateToolValue | undefined) ?? {
    enabled: Boolean(definition.required || definition.enabledByDefault),
    configuration: {},
  }
  const configuration = current.configuration
  return (
    <ConfigurableFieldShell
      id={`template-${definition.key}`}
      title={resolveLocalizedText(definition.label, locale)}
      description={
        definition.description
          ? resolveLocalizedText(definition.description, locale)
          : undefined
      }
      enabled={current.enabled}
      required={definition.required}
      disabled={disabled}
      error={error}
      onEnabledChange={(enabled) => onChange({ enabled, configuration })}
    >
      <div className="space-y-2 border-t border-border pt-4">
        <Label htmlFor={`template-${definition.key}-request`}>
          {t("workspace.agent.templates.requestForm.requestLabel")}
          <span aria-hidden="true"> *</span>
        </Label>
        <Textarea
          id={`template-${definition.key}-request`}
          aria-required="true"
          rows={4}
          value={String(configuration.request || "")}
          maxLength={definition.requestMaxLength}
          disabled={disabled}
          placeholder={t(
            "workspace.agent.templates.requestForm.requestPlaceholder"
          )}
          onChange={(event) =>
            onChange({
              enabled: current.enabled,
              configuration: {
                ...configuration,
                request: event.target.value,
              },
            })
          }
        />
        <p className="text-sm text-muted-foreground">
          {t("workspace.agent.templates.requestForm.requestHelp")}
        </p>
      </div>
    </ConfigurableFieldShell>
  )
}
